import React, { useMemo } from 'react';
import {
  ScrollView,
  usePageLayoutBodyScroll,
  usePageLayoutHeaderInset,
} from '@usepepper/sprout-kit-ui';
import { useTheme } from '@/contexts/theme-context';

/** Per-frame scroll events, so the bottom nav reacts without visible lag. */
const SCROLL_EVENT_THROTTLE_MS = 16;

export interface InsightsMobileFeedProps {
  /** The alert feed subtree — active feed above, hidden-alerts section below. */
  children: React.ReactNode;
}

/**
 * Owns the page's scroll surface: `PageLayout`'s body isn't height-bounded
 * inside the sales-hub shell, so it can't scroll itself.
 */
export const InsightsMobileFeed: React.FC<InsightsMobileFeedProps> = ({
  children,
}) => {
  const scrollProps = usePageLayoutBodyScroll();
  const headerInset = usePageLayoutHeaderInset();
  const theme = useTheme();

  const contentContainerStyle = useMemo(
    () => ({
      gap: '$8',
      // The bottom nav floats over the body and only hides once the feed
      // scrolls, so a short feed needs the nav's height here to be reachable.
      paddingBottom: '$72',
      paddingTop: headerInset + theme.sk.spacing.spaceLarge,
    }),
    [headerInset, theme],
  );

  return (
    <ScrollView
      {...scrollProps}
      contentContainerStyle={contentContainerStyle}
      flex={1}
      scrollEventThrottle={SCROLL_EVENT_THROTTLE_MS}
      showsVerticalScrollIndicator={false}
    >
      <>{children}</>
    </ScrollView>
  );
};
